import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { FormTextField, FormSelect, FormTextArea, FormRichTextEditor } from 'appSrc/components/UI/ReduxForm';
import style from './styles/style.module.css';


class ProductFields extends PureComponent {
    render() {
        const { userLists } = this.props;
        return (
            <div className={ style.productFields }>
                <Field
                id="title"
                name="title"
                label="Name"
                component={ FormTextArea }
                fullWidth />

                <Field
                id="price"
                name="price"
                label="Price"
                component={ FormTextField }
                internalLabel='$'
                fullWidth />

                <Field
                id="description"
                name="description"
                label="Description"
                component={ FormRichTextEditor }
                fullWidth />

                { this.props.showLists &&
                <Field
                id="listid"
                name="listid"
                component={ FormSelect }
                label="List"
                fullWidth
                required
                value={ userLists && userLists[0] && userLists[0].listid }
                options={ userLists.map( list => ( {
                    text: list.title,
                    value: list.listid,
                } ) ) } />
                }
            </div>
        );
    }
}


export default connect()( ProductFields );
